import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Customers from './pages/Customers';
import Restaurants from './pages/Restaurants';
import Riders from './pages/Riders';
import About from './pages/About';
import Contact from './pages/Contact';
import Careers from './pages/Careers';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/restaurants" element={<Restaurants />} />
        <Route path="/riders" element={<Riders />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
